import PromotionChallengeSearchForm from './PromotionChallengeSearchForm'
import { withPromotionChallengeSearchForm } from './withPromotionChallengeSearchForm'

const ConnectedPromotionChallengeSearchForm = withPromotionChallengeSearchForm(
  PromotionChallengeSearchForm
)

export { ConnectedPromotionChallengeSearchForm as PromotionChallengeSearchForm }
